    angular.module('GorillaBoy.directives')
    .directive('fileBrowserUpload', ['$rootScope', '$q', '$translate', '$timeout', 'FileService', 'DocumentService', 'BrowserService', 'MessageProvider', 'MessageManager', 'PathManager', 'ModalFactory', 'GUIDGenerator', 'SignalProvider', 'AppConstants', 'ClientMetricsService', '$log',
        function ($rootScope, $q, $translate, $timeout, FileService, DocumentService, BrowserService, MessageProvider, MessageManager, PathManager, ModalFactory, GUIDGenerator, SignalProvider, AppConstants, ClientMetricsService, $log) {
            var UPLOAD_TYPE = {
                'FOLDERS': 'folders',
                'FILES': 'files'
            };
            var getTemplate = function(uploadType, isDragDropEnabled) {
                if (isDragDropEnabled) {
                    return '<div class="file_input_div">' +
                    '<input tabindex="-1" id="id_file_input_pane" type="file" name="files[]" multiple directory webkitdirectory mozdirectory class="hidden fileInput jquery_file_upload_widget" />' +
                    '</div>';
                }
                if(uploadType === UPLOAD_TYPE.FILES) {
                    return '<div class="file_input_div">' +
                '<input tabindex="-1" id="id_file_input" type="file" name="files[]" multiple="multiple" class="hidden fileInput jquery_file_upload_widget" />' +
                '</div>';
                }
                else {
                    return '<div class="file_input_div">' +
                '<input tabindex="-1" id="id_folder_input" type="file" name="files[]" multiple directory webkitdirectory mozdirectory class="hidden fileInput jquery_file_upload_widget" />' +
                '</div>';
                }
            };
            return {
                restrict: 'E',
                scope: true,
                link: function (scope, element, attrs) {
                    //////////////////////////////////////
                    // SETUP
                    //////////////////////////////////////
                    // set constants used in this directive
                    var MAX_RETRY_LIMIT = 5,
                        RETRY_DELAY = 100,
                        DELAY = {
                            FILE_UPLOAD_RETRY: 5000
                        },
                        EMPTY_FILETREE_NODE = {
                        'id': null,
                        'name': null,
                        'folders': {},
                        'files': []
                        };

                    // set "global variable" used in this directive.
                    var fileTree = {
                        'id': PathManager.getUploadFolderId(),
                        'folders': {},
                        'files': []
                    };

                    var isDragDropEnabled = !!attrs.drag;

                    var inputElementIdentifier;
                    if(isDragDropEnabled) {
                        inputElementIdentifier = '#id_file_input_pane';
                    } else {
                        if(attrs.type === UPLOAD_TYPE.FILES) {
                            inputElementIdentifier = '#id_file_input';
                        } else {
                            inputElementIdentifier = '#id_folder_input';
                        }
                    }
                    
                    var uploadPromise = null,       // Promise object to schedule the next timer
                        currentUploads = 0,         // Count how many uploads are currently going up. Global variable to ensure closure does not conflict
                        jqueryFileUploadWidget = element.find(inputElementIdentifier),
                        fileCnt = 0;
                    var deregRootScopeDragStartListener = $rootScope.$on(SignalProvider.Document.StartDragging, rootScopeDragStartListener);
                    
                    scope.documentInputPaneId = GUIDGenerator.generate();

                    scope.$on('$destroy', function() {
                        window.removeEventListener("beforeunload", closeUploadsWarning);
                        $timeout.cancel(uploadPromise);
                        uploadPromise = null;
                        deregRootScopeDragStartListener();
                        element.find(inputElementIdentifier).fileupload('destroy');
                    });

                    attrs.$observe('drag', function(drag) {
                        scope.dragUploadPane = drag;
                    });
                    
                    //////////////////////////////////////
                    // HELPER FUNCTIONS
                    //////////////////////////////////////
                    /*
                     * When there are many files and folders, too frequent calls to GB will result in "rate exceeded" error. 
                     * This function will retry the callInvoker until promise resolved or it exceeds MAX_RETRY_LIMIT
                     */
                    var callWithLinearRetries = function(callInvoker, deferred, retryCount){
                        if(!retryCount){
                             retryCount = 0;
                        }
                        function successCallBack(response){
                            deferred.resolve(response);
                        }
                        function errorCallBack(response){                         
                            if(retryCount < MAX_RETRY_LIMIT){
                                retryCount++;
                                $timeout(function() {
                                    return callWithLinearRetries(callInvoker, deferred, retryCount);
                                }, RETRY_DELAY);
                            }else{
                                $log.error("Exhausted Linear Retry Attempts; Error : " +
                                    JSON.stringify(response.data));
                                deferred.reject(response);
                            }
                        }
                        callInvoker().then(successCallBack, errorCallBack);
                        return deferred.promise;
                    };

                    /** 
                     * This function add relativePath field when it is necessary
                     * When user upload folder by clicking "upload folder" button, the relativePath is empty but
                     * webkitRelativePath contains the relativePath. This is different from what happens when user drag
                     * and drop folder. The rest of the logic are based on relativePath. The purpose of this function 
                     * is to format the relativePath when the folder selected by clicking the button. relativePath should contains
                     * the path info exactly the same as if the folder is dragged and dropped. 
                     */
                    var formatRelativePath = function(file) {
                        var thisFile = file.files[0];
                        if(thisFile.webkitRelativePath && thisFile.webkitRelativePath !== '') {
                            thisFile.relativePath = thisFile.webkitRelativePath.substr(0, (thisFile.webkitRelativePath.lastIndexOf('/') + 1));
                        }
                    };

                    /** 
                     * This function adds file to the correct postion in fileTree
                     * The output is a tree structure in which folders are nodes in tree and files in folders are 
                     * stored in "files" of the corresponding node.
                     */
                    var addToFileTree = function(file, fileTreeNode) {
                        var thisFile = file.files[0];

                        // skip hiden file and MS Word temp file
                        if(thisFile.name.startsWith('.') || thisFile.name.startsWith('~$')) {
                            return ;
                        }
                        // if thisFile is under current folder, add to 'files'
                        if(!thisFile.relativePath || thisFile.relativePath === '') {
                            fileTreeNode.files.push(file);
                        }
                        // if thisFile is under sub folder, use existing node or add new node 
                        else {
                            var pathComponents = thisFile.relativePath.split('/'),
                                subFolderName = pathComponents[0];
                            // update relativePath
                            pathComponents.shift();
                            thisFile.relativePath = pathComponents.join('/');
                            // if folder not exist, create a new node
                            if (!fileTreeNode.folders[subFolderName]) {
                                fileTreeNode.folders[subFolderName] = JSON.parse(JSON.stringify(EMPTY_FILETREE_NODE)); // deep copy
                            }
                            addToFileTree(file, fileTreeNode.folders[subFolderName]);
                        }
                    };

                    var scheduleUploads = function() {
                        // Step 2: Schedule a pending upload
                        if (!!uploadPromise) {
                            $timeout.cancel(uploadPromise);
                            uploadPromise = null;
                        }

                        if (!$rootScope.fileUploadQueue || !$rootScope.fileUploadQueue.length) {                            
                            window.removeEventListener("beforeunload", closeUploadsWarning);
                            return;
                        } else {
                            uploadPromise = $timeout(startChunkedUploads, DELAY.FILE_UPLOAD_RETRY);
                        }
                    };

                    var startChunkedUploads = function() {
                        // Step 3: Chunk 10 uploads (LIMITS.FILE_UPLOAD_CONCURRENT_UPLOADS) to start from this queue.
                        for (var j = 0; j < AppConstants.Upload.MAX_CONCURRENT_UPLOADS; j++) {
                            uploadFile();
                        }
                    };

                    var closeUploadsWarning = function() {
                        // Pending refactor, will move this to Message Provider
                        return 'You still have ' + (currentUploads + $rootScope.fileUploadQueue.length) + ' uploads.' +
                            ' If you quit now, they will be aborted';
                    };
                    /** 
                     * This function add info to file object and pushes it to upload queue
                     */
                    var enqueueUploads = function(data, folderId, docId, CheckoutId) {
                        data.files[0].folderId = folderId;
                        data.files[0].docId = docId;
                        data.files[0].CheckoutId = CheckoutId;
                        data.files[0].uploadTempID = Math.random().toString(36) + Math.random().toString(36);

                        // move the file in uploading queue and broadcast the event
                        if (!$rootScope.fileUploadQueue) {
                            $rootScope.fileUploadQueue = [];
                        }
                        $rootScope.fileUploadQueue.push(data);
                        $rootScope.$broadcast(SignalProvider.Document.fileUploadStatusChange, 'moveToPre', data);
                        uploadFile();
                    };

                    /**
                     * This method creates new folder if folder in the fileTree does not exist.
                     * it also update the fileTree with newly created folder ID after the folder creation is done
                     */
                    var createFolderAndUpdateFileTree = function(folderName, subFolderNode, parentFolderId) {
                        var deferred = $q.defer();
                        if(subFolderNode.id) {
                            deferred.resolve();
                        }
                        else {
                            var retryCreateFolder = function() {
                                return FileService.createFolder(folderName, parentFolderId);
                            };
                            callWithLinearRetries(retryCreateFolder, $q.defer())
                            .then(function(newFolder) {
                                subFolderNode.id = newFolder.Folder.Metadata.Id;
                                subFolderNode.name = newFolder.Folder.Metadata.Name;
                                if(parentFolderId === scope.metadata.Id) {
                                    scope.fileManagerInstance.setFolders([newFolder.Folder.Metadata].concat(scope.fileManagerInstance.getFolders()));
                                    scope.folders.unshift(newFolder.Folder.Metadata);
                                }
                                deferred.resolve();
                            })
                            .catch(function() {
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailCannotCreateFolder(folderName), folderName, null);
                            });
                            
                        }
                        return deferred.promise;
                    };

                    /**
                     * This method recursively processes the FileTree by adding each files on the fileTree to uploading queue. 
                     * params: 
                     *      fileTreeNode: node in fileTree
                     *      parentFolderIDs: an array contains IDs of all the parent folders of the current folder 
                     */
                    var processFileTree = function(fileTreeNode, parentFolderIDs) {
                        var localFileTreeNode = angular.extend({}, fileTreeNode);
                        var params = {};
                        var curFolderIDPath = parentFolderIDs.slice();  // copy value instead of pass reference
                        curFolderIDPath.push(localFileTreeNode.id);
                        var retryGetFolder = function() {
                            return FileService.getFolder(localFileTreeNode.id, params, true);   // set "getAllPages = true" to get all the contents of the folder
                        };
                        callWithLinearRetries(retryGetFolder, $q.defer())
                        .then(function(folderDetails) {
                            // Upload files under current folder
                            angular.forEach(localFileTreeNode.files, function(fileData) {
                                // Check if the file is locked. If yes, CheckoutGuid
                                // The upload will fail if the file is locked by other user regardless if you have correct CheckoutGuid.
                                // So it is not necessary to check if CheckouteeID === current user
                                var CheckoutGuid,
                                    docId;

                                angular.forEach(folderDetails.Folder.Documents, function(document) {
                                    if(fileData.files[0].name === document.VersionMetadata.Name) {
                                        if(document.CheckoutInfo) {
                                            CheckoutGuid = document.CheckoutInfo.CheckoutGuid;
                                        }
                                        docId = document.Id;
                                    }
                                });
                                fileData.files[0].parentFolderIDs = curFolderIDPath;
                                enqueueUploads(fileData, localFileTreeNode.id, docId, CheckoutGuid);
                            });
                            // Recursively upload subfolders under current folder
                            if (Object.keys(localFileTreeNode.folders).length !== 0) {
                                // check if current folder contains the folder to be uploaded. If yes, recored folder ID in fileTree
                                angular.forEach(folderDetails.Folder.Folders, function(folder, folderIndex) {
                                    if(localFileTreeNode.folders[folder.Name]) {
                                        localFileTreeNode.folders[folder.Name].id = folder.Id;
                                        localFileTreeNode.folders[folder.Name].name = folder.Name;
                                    }
                                });
                                // Go through all the folders to be uploaded, if it does not exist, create. 
                                // Then process the next level. 
                                angular.forEach(localFileTreeNode.folders, function(subFolderNode, subFolderName) {
                                    createFolderAndUpdateFileTree(subFolderName, subFolderNode, localFileTreeNode.id).then(function() {
                                        processFileTree(subFolderNode, curFolderIDPath);
                                    });
                                });
                            }
                        })
                        .catch(function() {
                            MessageManager.addErrorUploadMessage(MessageProvider.uploadFailCannotAccessFolder(localFileTreeNode.name), localFileTreeNode.name, null);
                        });
                        
                        // clean up file tree
                        fileTreeNode.files = [];
                        fileTreeNode.folders = {};
                    };

                    /** 
                     * This function initiates upload request to GB.
                     * If the number of current upload files exceeds MAX_CONCURRENT_UPLOADS, it will re-schedule upload for later. 
                     */
                    var uploadFile = function() {
                        // Step 1: Upload an individual file or leave it in the queue
                        if (currentUploads >= AppConstants.Upload.MAX_CONCURRENT_UPLOADS) {
                            scheduleUploads();
                            return;
                        } else {
                            if (!$rootScope.fileUploadQueue || !$rootScope.fileUploadQueue.length) {
                                window.removeEventListener("beforeunload", closeUploadsWarning);
                                return;
                            }
                            	
                            // Start uploads
                            var fileToUpload = $rootScope.fileUploadQueue.pop(); // fileToUpload: A temporary copy to be used in the callback
                            // move the file to be uploaded to "uploading list"($rootScope.fileUnderUploading)
                            if(!$rootScope.fileUnderUploading) {
                                $rootScope.fileUnderUploading = {};
                            }
                            $rootScope.fileUnderUploading[fileToUpload.files[0].uploadTempID] = fileToUpload;
                            // broadcast the operation to inform file browser to update view
                            $rootScope.$broadcast(SignalProvider.Document.fileUploadStatusChange, 'moveToIng', fileToUpload);
                            if (fileToUpload.files[0].name.length > AppConstants.Upload.MAX_NAME_LENGTH) {
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailNameTooLong, null, [fileToUpload.files[0]]);
                                return;
                            } else if (fileToUpload.files[0].size > 5000000000) { // If file is larger than 5GB
                                // TODO (vivitsum): Ideally, we should switch to multipart uploads, so that files of any size can be uploaded
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailSizeTooLarge, null, [fileToUpload.files[0]]);
                                return;
                            }

                            currentUploads = currentUploads + 1;

                            window.addEventListener("beforeunload", closeUploadsWarning);                            

                            var fileObj = fileToUpload.files[0];
                            fileObj.contentType = scope.getContentType(fileObj);
                            DocumentService.InitiateDocumentVersionUpload(fileObj.docId, fileObj.overrideName || fileObj.name, fileObj.contentType, fileObj.size, fileObj.folderId, fileObj.CheckoutId)
                            .success(function(data) {
                                currentUploads--;

                                var docMetadata = data.Metadata,
                                    docVersionMetadata = data.Metadata.LatestVersionMetadata,
                                    docId = data.Metadata.Id;
                                // new API deprecated VersionMetadata field in docMetadata, and uses LatestVersionMetadata field instead.
                                // However, client side still uses VersionMetadata to populate data on page.
                                // Assign value to VersionMetadatav filed to avoid page broken.
                                delete data.Metadata.LatestVersionMetadata;

                                if (scope.userActionsMap) {
                                    delete scope.userActionsMap[docId];
                                }

                                docVersionMetadata.VersionId = docVersionMetadata.Id;
                                docMetadata.VersionMetadata = docVersionMetadata;
                                fileObj.docMetadata = docMetadata;
                                var s3url = data.DocumentVersionUrl;
                                var signedHeaders = data.UploadMetadata.SignedHeaders;

                                if (s3url && signedHeaders) {
                                    fileToUpload.url = s3url;
                                    fileObj.documentId = docId;
                                    fileObj.versionId = docVersionMetadata.Id;

                                    // List View: Do not need to do anything. The change has already been broadcasted. 
                                    

                                    fileToUpload.File = fileObj;
                                    fileToUpload.paramName = "File";
                                    fileToUpload.headers = signedHeaders;
                                    fileToUpload.submit();
                                } else {
                                    $log.error("Did not receive the S3 url or signed headers.");
                                }
                            })
                            .error(function(data, status, headers, config) {
                                currentUploads--;
                                scheduleUploads();
                                var errorShown = false;
                                $log.error("Failed to upload file with name " + fileToUpload.files[0].name);
                                // TODO(fxc): Follow up with design and use the pattern from a failed service call here.
                                if (data && data.Message) {
                                    if (data.Message.indexOf('ProhibitedStateException') === 0) {
                                        MessageManager.addErrorUploadMessage($translate.instant('CHECKIN_CHECKOUT.ERROR_WHILE_SINGLE_FILE_UPLOAD_DUE_RENAME'));
                                        errorShown = true;
                                    } else if (data.Message.indexOf('ResourceAlreadyCheckedOutException') >= 0) {
                                        MessageManager.addErrorUploadMessage($translate.instant('CHECKIN_CHECKOUT.ERROR_WHILE_SINGLE_FILE_UPLOAD'));
                                        errorShown = true;
                                    } else if (data.Message.indexOf('EntityAlreadyExistsException') >= 0) {
                                        MessageManager.addErrorUploadMessage(MessageProvider.uploadFailAlreadyExists(fileToUpload.files[0].name), null, [fileToUpload.files[0]]);
                                        errorShown = true;
                                    } else if (data.Message.indexOf('EntityNotExistsException') >= 0) {
                                        MessageManager.addErrorUploadMessage(MessageProvider.uploadFailFolderNotExists(fileToUpload.files[0].name), null, [fileToUpload.files[0]]);
                                        errorShown = true;
                                    } else if (data.Message.indexOf('StorageLimitExceededException') >= 0 || data.Message.indexOf('StorageLimitWillExceedException') >= 0) {
                                        MessageManager.addErrorUploadMessage(MessageProvider.uploadFailStorageLimitWillExceed());
                                        errorShown = true;
                                    } else if (data.Message.indexOf('FileSizeLimitExceededException') >= 0 ) {
                                        MessageManager.addErrorUploadMessage(MessageProvider.uploadFailFileSizeWillExceed());
                                        errorShown = true;
                                    }
                                } else if (data && data.message) {
                                    if (data.message.indexOf('ValidationException') >= 0) {
                                        MessageManager.addErrorUploadMessage(MessageProvider.uploadFailInvalidFileName());
                                        errorShown = true;
                                    }
                                }
                                if (!errorShown) {
                                    MessageManager.addErrorUploadMessage(MessageProvider.uploadFailDefault(fileToUpload.files[0].name), null, [fileToUpload.files[0]]);
                                }
                            });
                        }
                    };

                    function rootScopeDragStartListener() {                        
                        if (scope.dragUploadPane) {
                            scope.dragToUpload = true;    
                        }                        
                    }

                    /*
                     * Determine if files in a file list are all files (does not contain folder)
                     * input: file list
                     * return: promise
                     */
                    function areAllFiles(fileList) {
                        var areFiles = [];
                        for (var i=0; i<fileList.length; i++) {
                            areFiles.push(isFile(fileList[i]));
                        }
                        return $q.all(areFiles);
                    }

                    function isFile(file) {
                        var deferred = $q.defer();
                        // FileReader throw error if the given file is actually a folder
                        // The web is full of heuristics to use alternative methods, namely item.size and item.type
                        // but the altiernatives are based on false assumptions. FileReader is the only reliable way
                        // to determine whether an item is a folder or file. Therefore, it cannot be avoided.  
                        var reader = new FileReader();
                        reader.onprogress = function() {
                            reader.abort(); // no need to read the whole file
                            deferred.resolve();
                        };
                        reader.onload = reader.onprogress;         // for handling zero byte files
                        reader.onerror = function() {
                            deferred.reject();
                        };
                        reader.readAsArrayBuffer(file); 
                        return deferred.promise;
                    }

                    //////////////////////////////////////
                    // MAIN LOGICS
                    //////////////////////////////////////
                    var uploadConfig = {
                        // Upload via PUT
                        type: AppConstants.HttpMethods.PUT,
                        // Disable multipart form uploads. If internet explorer, set to true to submit form data
                        multipart: false,
                        // The jQuery object for the file input field to listen on.
                        fileInput: $(jqueryFileUploadWidget),
                        // Enable server-side encryption for all S3 uploads
                        add: function(event, data) {
                            if ((!!scope.dragUploadPane && !!scope.dragToUpload ||
                                    !scope.dragUploadPane && !scope.dragToUpload) &&
                                (scope.layout.showUploadPane === undefined || scope.layout.showUploadPane)) {
                                // Initialize fileCnt for this batch of files
                                if (fileCnt === 0) {
                                    fileCnt = data.originalFiles.length;
                                }
                                // Update folder ID for the current folder
                                fileTree.id = PathManager.getUploadFolderId();
                                // Formatting relativePath when necessary
                                formatRelativePath(data);
                                // Add current file to fileTree
                                addToFileTree(data, fileTree);
                                fileCnt--;
                                // When it comes to the last file in batch, process FileTree to execute upload
                                if (fileCnt === 0) {
                                    // Check if current batch contains folder for Safari because it does not support folder upload. 
                                    if(BrowserService.isSafari()) {
                                        areAllFiles(data.originalFiles).then(function() {
                                            ClientMetricsService.recordCounterEvent({name: 'FileBrowser.DragAndDropUpload'}, 1);
                                            processFileTree(fileTree, []);
                                        }, function() {
                                            // if this batch contains folder, clean the fileTree, do not process them
                                            fileTree.files = [];
                                            fileTree.folders = {};
                                            MessageManager.addInfoMessage($translate.instant('MESSAGES.FOLDER_UPLOAD_FAIL_BROWSER_NOT_SUPPORT'));
                                        });
                                    } else {
                                        ClientMetricsService.recordCounterEvent({name: 'FileBrowser.DragAndDropUpload'}, 1);
                                        processFileTree(fileTree, []);
                                    }
                                }
                            } else {
                                //TODO(fxc): Followup with design. Do we need an error message for lack of permissions?
                            }
                        },
                        drop: function(e, data) {
                            return isDragDropEnabled;
                        },
                        submit: function(e, data) {
                            return true;
                        },
                        send: function(e, data) {
                            data.contentType = data.File.contentType;
                            return true;
                        },
                        progress: function(e, data) {
                            var progress = parseInt(data.loaded / data.total * 100, 10);
                            // broadcast the progress to file browser
                            $rootScope.$broadcast(SignalProvider.Document.uploadProgress, progress, data.File.folderId, data);
                        },
                        fail: function(e, data) {
                            // Abort the file uploads.
                            $log.error("AbortDocumentVersionUpload called for " + data.File.documentId + " reason: " + JSON.stringify(data.messages) + JSON.stringify(data._response));
                            // Notify user of upload failure.
                            var res = data._response.jqXHR;
                            if (res.status === 403 &&  res.responseText && res.responseText.indexOf('Access Denied') > 0) {
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailKmsError(data.File.name, window.location.hostname), null, [data.File]);
                                $rootScope.metricServiceInstance.newCounterMetric('FileBrowser.Error.' + res.status + '.KMS.VersionUpload');
                            } else {
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailDefault(data.File.name), null, [data.File]);
                                $rootScope.metricServiceInstance.newCounterMetric('FileBrowser.Error.' + res.status + '.VersionUpload');
                            }

                            // Abort the file upload.
                            DocumentService.deleteDocumentVersion(data.File.documentId, data.File.versionId);

                            if (!$rootScope.fileUploaded) {
                                $rootScope.fileUploaded = {};
                            }
                            $rootScope.fileUploaded[data.files[0].uploadTempID] = data;
                            delete $rootScope.fileUnderUploading[data.files[0].uploadTempID];
                            $rootScope.$broadcast(SignalProvider.Document.fileUploadStatusChange, 'moveToDone', data);
                            $rootScope.$broadcast(SignalProvider.Document.fileUploadFailed, data);
                        },
                        done: function(event, data) {
                            // Finalize the upload and init document controls.
                            DocumentService.updateDocumentVersion(data.File.documentId, data.File.versionId)
                            .success(function() {
                                uploadFile();
                                $rootScope.$broadcast(SignalProvider.Document.Uploaded, data.File.documentId, data.File.versionId);
                                MessageManager = null;
                                $log.info("File upload done for file: " + data.File.name);
                            })
                            .error(function(d, status, headers, config) {
                                $log.error("File upload failed for file: " + data.File.documentId);
                                // Notify user of upload failure.
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailDefault(data.File.name), null, [data.File]);
                                // Abort the file upload.
                                DocumentService.deleteDocumentVersion(data.File.documentId, data.File.versionId);
                            });
                            // add the file do "done", remove it from uploading, and broadcast the event
                            if (!$rootScope.fileUploaded) {
                                $rootScope.fileUploaded = {};
                            }
                            $rootScope.fileUploaded[data.files[0].uploadTempID] = data;
                            delete $rootScope.fileUnderUploading[data.files[0].uploadTempID];
                            $rootScope.$broadcast(SignalProvider.Document.fileUploadStatusChange, 'moveToDone', data);

                        }
                    };

                    if (!isDragDropEnabled) {
                        uploadConfig.dropZone = null;
                    }

                    $(jqueryFileUploadWidget).fileupload(uploadConfig);
                },
                template: function(tElement, tAttrs) {
                    return getTemplate(tAttrs.type, !!tAttrs.drag);
                }  
            };
        }
    ]);
